import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isEngraving = searchParams.get('type') === 'engraving';

  return (
    <div className="contact-page">
      <div className="contact-page-content">
        <h1>{isEngraving ? 'Custom Engraving Inquiry' : 'Contact Us'}</h1>
        <div className="contact-section">
          {isEngraving ? (
            <>
              <div className="engraving-highlight">
                <h2>Request Custom Engraving</h2>
                <p>
                  For custom engraving services, please contact us directly. We offer professional engraving 
                  on all our trophies, medals, and awards to personalize them for your special occasion.
                </p>
                <p>
                  Whether you need a single item engraved or multiple pieces, our team will work with you 
                  to create the perfect personalized touch for your awards.
                </p>
              </div>
            </>
          ) : (
            <p>
              Get in touch with Quirke Trophies for custom orders, quotes, or any questions you may have.
            </p>
          )}
          
          <div className="contact-info">
            <div className="contact-item">
              <h3>Phone</h3>
              <p>
                <a href="tel:0527430288" className="contact-link">(052) 743 0288</a>
              </p>
            </div>
            <div className="contact-item">
              <h3>Email</h3>
              <p>
                <a href="mailto:quirketrophies@mail.com" className="contact-link contact-email">quirketrophies@mail.com</a>
              </p>
            </div>
          </div>
          
          {!isEngraving && (
            <p className="contact-note">
              For custom orders and bulk purchases, please contact us directly for a personalized quote.
            </p>
          )}
          
          <p className="contact-note contact-engraving-note">
            For custom engraving, please inquire directly with us.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;

